import React from "react";
import Image from "../../../Elements/Image/Image.tsx";
import useInbox from "hooks/useInbox.ts";

const InboxItemSelectComponent = ({ id }) => {
  const { getSelectedList, setSelectedList, setCurrentSelectFilter } =
    useInbox();
  const isItemSelected = getSelectedList().includes(id);
  const selectToggleAction = (e) => {
    e.stopPropagation();
    setCurrentSelectFilter("");
    const newList = getSelectedList().includes(id)
      ? getSelectedList().filter((item) => item !== id)
      : [...getSelectedList(), id];
    setSelectedList(newList);
  };
  return (
    <div className="select-element" onClick={selectToggleAction}>
      <Image name={`checkbox-${isItemSelected ? "" : "un"}checked`} ext="svg" />
    </div>
  );
};
export default InboxItemSelectComponent;
